<template>
  <div>

      <v-list-group v-if="getBookmark">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="padding: 0 16px" class="text-uppercase .v-size--default" v-text="$t('viewJourneys')">
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item @click="goToJourney()">
          <v-list-item-content>
            <v-list-item-title style="padding: 0 16px;margin-left:6%">
                                      {{$t('continueLastJourney')}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>



    </div>

</template>
<script>

export default {
    name: 'bookmark',
    components: {
    },
    props: {
        loginPage: {
            type: Boolean,
            required: false
      }
    },
    data () {
        return {

        }
    },

//non serve questo mounted
    mounted(){


  },
    computed: {
        getBookmark: {
            get: function () {
                return this.$store.getters.getBookmark;
            }
        }
    },
    methods: {
      goToJourney(){
        this.$router.push({name:'singleJourneyView',query:{'idJourney':this.getBookmark}})
      }
  }
};
</script>

<style>
.v-list-item__title{
  font-size:0.875rem!important;
}
.activeLanguage{
  font-weight: bold;
  color:#38737A!important; 
  text-decoration: underline;
  text-decoration-color:#38737A;
}
.v-list-item{
margin-left:0px;
padding-left: 0px;
}

.v-menu__content{
right: 0px;
}
</style>